import { 
/* Scales */
CategoryScale, LinearScale, 
/* Elements */
BarElement, PointElement, LineElement, ArcElement, 
/* Features */
Title, Tooltip, Legend, Filler, } from 'chart.js';
import { Corsair } from './corsair';
import { Datalabels } from './datalabels';
import { LegendStatePlugin } from './legendStatePlugin';
/* This plugins always enabled for every chart */
export const defaultPlugins = [
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    ArcElement,
    Filler,
    Legend,
    Title,
    Tooltip,
    Corsair,
    Datalabels,
];
/* This plugins enabled only when they used in chart options */
export const optionalPlugins = [LegendStatePlugin];
export { ChartLegend } from './legendStatePlugin/ChartLegend';
export { useTooltipShadowPlugin } from './useTooltipShadowPlugin';
